module.exports = __webpack_public_path__ + "static/media/icomoon.030b53be.svg";